
import { defineComponent, inject } from 'vue'
import LoadingPulse from '@/components/shared/LoadingPulse.vue'
import { PROVIDER_CONSTANTS } from '@/constants/provider.constants'
import { MiscellaneousService } from '@/services/miscellaneous.service'
import { ConfirmEmailMessage } from '@/@types/messages/ConfirmEmailMessage'
import Toaster from '@meforma/vue-toaster'
import { ErrorsResponse } from '@/@types/responses/common/ErrorsResponse'

export default defineComponent({
  name: 'EmailConfirmation',
  components: {
    LoadingPulse
  },
  props: {
    id: {
      type: String,
      required: true
    },
    token: {
      type: String,
      required: true
    }
  },
  setup() {
    const miscellaneousService = inject(PROVIDER_CONSTANTS.miscellaneousService) as MiscellaneousService
    const toast = inject(PROVIDER_CONSTANTS.toaster) as Toaster

    return {
      miscellaneousService,
      toast
    }
  },
  data() {
    return {
      showErrorMessage: false,
      errorMessage: ''
    }
  },
  mounted() {
    this.confirmEmail()
  },
  methods: {
    confirmEmail(): void {
      const confirmEmailMessage = new ConfirmEmailMessage(this.token, this.id)
      this.miscellaneousService.confirmEmail(confirmEmailMessage).then(() => {
        this.toast.success('Email address confirmed successfully.')
        this.$router.push('/')
      }).catch(error => {
        const errorsResponse = error as ErrorsResponse

        this.errorMessage = errorsResponse.errors.map(e => e.message).join("\r\n")
        this.showErrorMessage = true
      })
    }
  }
})
